import { Button } from '@jouzen/ecom-components/v3/Button';
import { AccordionItem } from '@jouzen/ecom-components/v4/Accordion';
import { useLocale, useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import RichText from '@/app/components/RichText';
import TwoColumnAccordionSection from '@/app/components/TwoColumnAccordionSection';
import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

import perimenopauseAccordionData from '../_data/perimenopauseAccordionData';

const PerimenopauseAccordion = () => {
  const t = useTranslations();
  const locale = useLocale();
  const localePartialUrl = getLocalePartialUrl(locale);

  const data = perimenopauseAccordionData.map((item) => {
    // Determine the correct href for the accordion item, prioritizing blogHref if it exists
    const href = item.blogHref
      ? `https://ouraring.com/blog${localePartialUrl}${item.blogHref}`
      : item.href;

    // Create analytic tracking function for clicks on the accordion links
    const handleOnClick = async () => {
      await window.ouraAnalytics.track(EventType.LearnMore, {
        cta: 'learn more',
        location: 'faqs',
        path: href,
      });
    };

    return {
      ...item,
      href,
      onClick: handleOnClick,
    };
  });

  return (
    <TwoColumnAccordionSection
      dataCy="perimenopause-accordion"
      imageColStart="full"
      imageAltKey="perimenopause_lifestyle_alt_three"
      imageSrcSet={[
        {
          media: '(max-width: 1023px)',
          src: 'perimenopause-lifestyle-three.jpg?fit=crop&crop=focalpoint&fp-x=0.4&fp-y=0.6&fp-z=1.05',
        },
        {
          media: '(min-width: 1024px)',
          src: 'perimenopause-lifestyle-three.jpg?flip=h',
        },
      ]}
    >
      {data.map((item) => (
        <AccordionItem
          key={item.id}
          className={'bg-[#ece6de]'}
          header={t(item.header)}
        >
          <RichText messageKey={item.content} />
          {item.href && (
            <Button
              className="mt-4 block w-fit font-bold hover:bg-sandstone-100"
              variant="secondary-light"
              href={item.href}
              target={item.target}
              onClick={item.onClick}
            >
              <RichText messageKey="learn_more" />
            </Button>
          )}
        </AccordionItem>
      ))}
    </TwoColumnAccordionSection>
  );
};

export default PerimenopauseAccordion;
